module.exports = __webpack_public_path__ + "img/waistband length.62c7fd7e.png";